export const GroupIconSvg = (props = {}) => (
  <svg
    {...props}
    width={props.width || "20"}
    height={props.height || "20"}
    id="icon"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10,30H8V27H4v3H2V27a2.0023,2.0023,0,0,1,2-2H8a2.0023,2.0023,0,0,1,2,2Z" />
    <path d="M30,30H28V27H24v3H22V27a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z" />
    <path d="M20,30H18V27H14v3H12V27a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z" />
    <circle cx="16" cy="22" r="2" />
    <circle cx="6" cy="22" r="2" />
    <circle cx="26" cy="22" r="2" />
    <circle cx="21" cy="18" r="2" />
    <circle cx="11" cy="18" r="2" />
    <path d="M26,14H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,26,14ZM6,4v8H26V4Z" />
    <rect
      fill="none"
      height="32"
      width="32"
      data-name="<Transparent Rectangle>"
      id="_Transparent_Rectangle_"
    />
  </svg>
);
